/**
 * i18next の初期化
 * 参考：
 * https://react.i18next.com/latest/using-with-hooks
 * https://qiita.com/Syoitu/items/98343af1bd69e7c38283
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 言語jsonファイルのimport
import translationEn from './en.json';
import translationJa from './ja.json';

const resources = {
  ja: {
    translation: translationJa,
  },
  en: {
    translation: translationEn,
  },
};

const initI18n = async () => {
  const basePath = process.env.REACT_APP_ROUTER_BASEPATH || '';
  const language = window.location.pathname.startsWith(`${basePath}/en`) ? 'en' : 'ja';
  await i18n.use(initReactI18next).init({
    resources,
    lng: language,
    interpolation: {
      escapeValue: false,
    },
  });
};

void initI18n();

export default i18n;
